import React from 'react'
import { ImCross } from 'react-icons/im'
import { Grid } from 'semantic-ui-react'
import styles from '../styles.module.less'

export interface ClosingListItemProps {
  children: React.ReactNode
  onClose: () => void
  showRemoveButton: boolean
}

const ClosingListItem = ({ children, onClose, showRemoveButton }: ClosingListItemProps) => {
  return (
    <Grid columns={'equal'}>
      <Grid.Row>
        <Grid.Column className={'closing-list-item-content'}>{children}</Grid.Column>
        {showRemoveButton && (
          <Grid.Column width={1}>
            <div className={styles.deleteButtonWrap}>
              <button onClick={onClose} className={styles.btnLink} type={'button'}>
                <ImCross />
              </button>
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  )
}

export default ClosingListItem
